import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BannerTextoGrandeContainerService {

  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getBannerTextoGrande(id: string): Observable<any> {
    return this.getBannerTextoGrandeContents(id).pipe(
      map(res => this.buildResponseBannerTextoGrandeObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryBannerTextoGrandeContents[0].flatData;
  }

  private getBannerTextoGrandeContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryBannerTextoGrandeContents(filter: "id eq '${id}'") {
          flatData {
            nome
            titulo
            subtitulo
            imagem {
              url
            }
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseBannerTextoGrandeObject(data: any) {
    return {
      title: data.titulo,
      subtitle: data.subtitulo,
      image: data.imagem && data.imagem[0]
        ? data.imagem[0].url
        : null,
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
